import type { ITeacherSubscription } from '@/Module/Subscription/Model/DataModel';

export const SAMPLE_SUBSCRIPTION_TEACHERS: ITeacherSubscription[] = [
  {
    name: 'حمیدرضا جوشقانی',
    grade: 'فیزیک',
    img: 'tizhoshan-joshaghani',
    color: 'orange',
    url: 'https://ino.school/teacher/%d8%ad%d9%85%db%8c%d8%af%d8%b1%d8%b6%d8%a7-%d8%ac%d9%88%d8%b4%d9%82%d8%a7%d9%86%db%8c/',
  },
  {
    name: 'علیرضا شیخ عطار',
    grade: 'ریاضی‌',
    img: 'tizhoshan-sheykhatar',
    color: 'pink',
    url: 'https://ino.school/teacher/%d8%b9%d9%84%db%8c%d8%b1%d8%b6%d8%a7-%d8%b4%db%8c%d8%ae-%d8%b9%d8%b7%d8%a7%d8%b1/',
  },
  {
    name: 'علیرضا معماریان',
    grade: 'ریاضی‌',
    img: 'tizhoshan-meamarian',
    color: 'primary',
    url: 'https://ino.school/teacher/%d8%b9%d9%84%db%8c%d8%b1%d8%b6%d8%a7-%d9%85%d8%b9%d9%85%d8%a7%d8%b1%db%8c%d8%a7%d9%86/',
  },
  {
    name: 'محمد حسین ملکوتی',
    grade: 'شیمی',
    img: 'tizhoshan-malakoti',
    color: 'orange',
    url: 'https://ino.school/teacher/%d9%85%d8%ad%d9%85%d8%af-%d8%ad%d8%b3%db%8c%d9%86-%d9%85%d9%84%da%a9%d9%88%d8%aa%db%8c/',
  },
  {
    name: 'محمد رزمی',
    grade: 'فارسی',
    img: 'tizhoshan-razmi',
    color: 'primary',
    url: 'https://ino.school/teacher/%D9%85%D8%AD%D9%85%D8%AF-%D8%B1%D8%B2%D9%85%DB%8C/',
  },
];
